"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

/**
 * Neutrals and Blue are special.
 * They need more variations to properly express all of our UI.
 */
var _default = {
  neutral: {
    N1: '#F9F9FB',
    N2: '#F5F6F7',
    N3: '#EDF0F2',
    N4: '#E4E7EB',
    N5: '#C7CED4',
    N6: '#A6B1BB',
    N7: '#7B8B9A',
    // Large Text AA
    N8: '#66788A',
    // Normal Text AA
    N9: '#425A70',
    // Normal Text AAA
    N10: '#234361',
    // Normal Text AAA
    // Transparent variants.
    N1A: 'rgba(67, 90, 111, 0.04)',
    N2A: 'rgba(67, 90, 111, 0.06)',
    N3A: 'rgba(67, 90, 111, 0.09)',
    N4A: 'rgba(67, 90, 111, 0.14)',
    N5A: 'rgba(67, 90, 111, 0.3)',
    N6A: 'rgba(67, 90, 111, 0.47)',
    N7A: 'rgba(67, 90, 111, 0.7)',
    N8A: 'rgba(67, 90, 111, 0.81)'
  },
  blue: {
    B1: '#f7f9fd',
    B2: '#f1f7fc',
    B3: '#e9f2fa',
    B4: '#ddebf7',
    B5: '#b7d4ef',
    B6: '#8fbce6',
    B7: '#579ad9',
    // Large Text AA
    B8: '#3d8bd4',
    // Normal Text AA
    B9: '#1070ca',
    // Normal Text AAA
    B10: '#084b8a',
    // Normal Text AAA
    // Transparent variants.
    B1A: 'rgba(16, 112, 202, 0.04)',
    B2A: 'rgba(16, 112, 202, 0.06)',
    B3A: 'rgba(16, 112, 202, 0.09)',
    B4A: 'rgba(16, 112, 202, 0.14)',
    B5A: 'rgba(16, 112, 202, 0.3)',
    B6A: 'rgba(16, 112, 202, 0.47)',
    B7A: 'rgba(16, 112, 202, 0.7)',
    B8A: 'rgba(16, 112, 202, 0.81)'
  }
};
exports.default = _default;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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


//////////////////
// WEBPACK FOOTER
// ./~/evergreen-ui/commonjs/theme/src/default-theme/foundational-styles/scales.js
// module id = 20
// module chunks = 0